export const LOGO_PUBLIC = "/assets/images/logo721x718.png";
